// components/help/LocaleToggle.tsx
'use client'
import { useRouter } from 'next/navigation'
import { useLocale, useSetLocale } from '@/lib/i18n/hooks'

export function LocaleToggle() {
  const router = useRouter()
  const locale = useLocale()
  const setLocale = useSetLocale()
  return (
    <button
      onClick={() => { setLocale(locale === 'es' ? 'en' : 'es'); router.refresh() }}
      className="rounded-full border border-[var(--redy-border)] px-3 py-1 text-[13px] font-semibold text-[var(--redy-charcoal)]"
      aria-label="Cambiar idioma / Switch language"
    >
      {locale === 'es' ? 'EN' : 'ES'}
    </button>
  )
}
